import type { MiniGamePageConfig } from '@/app/(football)/[team]/mini-game/_context/types';

export const uhdfcConfig: MiniGamePageConfig = {
  game: {
    colors: ['#141cff', '#ffea61'],
    background: {
      color: '#f0fbff',
    },
  },
  titleImage: {
    width: 276,
    height: 62,
    alt: '울산 HD FC 미니게임 타이틀',
    marginTop: 72,
  },
  eventPeriod: {
    endDate: '2026-12-31T23:59:59+09:00',
  },
};
